var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from "react-redux";
import { selectPages, selectStyles } from "@adm-media/adam-store-plugin";
import Slider from "../Slider/Slider";
import Hero from "../Hero/Hero";
var HomepageHeader = function (props) {
    var styles = useSelector(selectStyles);
    var pages = useSelector(selectPages);
    var slides = pages === null || pages === void 0 ? void 0 : pages.filter(function (page) {
        return page.is_highlighted;
    });
    return (slides === null || slides === void 0 ? void 0 : slides.length) && styles.enable_homepage_slider ? _jsx(Slider, __assign({}, props)) : _jsx(Hero, __assign({}, props));
};
export default HomepageHeader;
